function createTOC() {
  const contentDiv = document.querySelector('.content-editor');
  const toc = document.getElementById('content-toc');
  if (!toc || !contentDiv) {
    return;
  }

  const headings = contentDiv.querySelectorAll('h1, h2, h3, h4, h5, h6');

  const ol = document.createElement('ol');
  toc.appendChild(ol);

  let currentLevel = 1;
  let currentParent = ol;

  headings.forEach((heading) => {
    const level = parseInt(heading.tagName.charAt(1));
    const text = heading.textContent.trim();
    const id = heading.id || text.toLowerCase().replace(/\s+/g, '-');
    heading.id = id; // Set the id attribute of the heading to the generated id
    if (level > currentLevel) {
      for (let i = currentLevel; i < level; i++) {
        const newOl = document.createElement('ol');
        if (newOl && currentParent?.lastElementChild) {
          currentParent.lastElementChild.appendChild(newOl);
          currentParent = newOl;
        }
      }
    } else if (level < currentLevel) {
      for (let i = currentLevel; i > level; i--) {
        currentParent = currentParent.parentElement.parentElement;
      }
    }

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.textContent = text;
    a.setAttribute('href', `#${id}`);
    li.appendChild(a);
    currentParent.appendChild(li);

    currentLevel = level;
  });
}

// Call the function to create TOC
createTOC();
